export const syncLogTypes = {
  product: 'products',
  stock: 'stock',
  price: 'price',
  order: 'orders',
  orderStatus: 'orderstatus',
};

export const syncLogTypeMappings = [
  {
    key: syncLogTypes.product,
    displayLabel: 'Product',
  },
  {
    key: syncLogTypes.stock,
    displayLabel: 'Stock',
  },
  {
    key: syncLogTypes.price,
    displayLabel: 'Price',
  },
  {
    key: syncLogTypes.order,
    displayLabel: 'Order',
  },
  {
    key: syncLogTypes.orderStatus,
    displayLabel: 'Order Status',
  },
];

export const syncLogStatuses = {
  fail: 0,
  success: 1,
};

export const syncLogStatusMappings = [
  {key: syncLogStatuses.fail, displayLabel: 'Fail', color: 'red'},
  {key: syncLogStatuses.success, displayLabel: 'Success', color: 'green'},
];
